import { render, staticRenderFns } from "./AcceptQuoteVersionning.vue?vue&type=template&id=2acabfc6&"
import script from "./AcceptQuoteVersionning.vue?vue&type=script&lang=js&"
export * from "./AcceptQuoteVersionning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports